AOS.init();

var swiper = new Swiper(".prodSlider", {
  slidesPerView: 4,
  spaceBetween: 30,
  navigation: {
    nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    150: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    769: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
  },
});
var relatedProduct = new Swiper(".relatedProduct-slider", {
  slidesPerView: 1,
  loop:false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var swiper = new Swiper(".testiSlider", {
  slidesPerView: 3,
  spaceBetween: 30,
  centeredSlides: true,
  initialSlide: 0,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    150: {
      slidesPerView: 1.1,
      spaceBetween: 10,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    769: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1025: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
  },
});

// SCRIPT FOR ACCORDIANS FAQS

document.addEventListener('DOMContentLoaded', function () {
  function faqsAccordion() {
    var accordionSections = document.querySelectorAll(".faq__accordion , .prodDetailAccord, .prodFaqAccrd");

    accordionSections.forEach(section => {
      var accordionItemHeaders = section.querySelectorAll(".accordion-item-header");

      if (accordionItemHeaders.length > 0) {
        var firstAccordionItemHeader = accordionItemHeaders[0];
        var firstAccordionItemBody = firstAccordionItemHeader.nextElementSibling;

        if (firstAccordionItemBody) {
          firstAccordionItemHeader.classList.add("active");
          firstAccordionItemBody.style.maxHeight = firstAccordionItemBody.scrollHeight + "px";
        }
      }

      accordionItemHeaders.forEach(accordionItemHeader => {
        accordionItemHeader.addEventListener("click", event => {
          var accordionItemBody = accordionItemHeader.nextElementSibling;

          accordionItemHeaders.forEach(item => {
            if (item !== accordionItemHeader) {
              item.classList.remove("active");
              // Check if the next sibling exists before accessing it
              var body = item.nextElementSibling;
              if (body) {
                body.style.maxHeight = 0;
              }
            }
          });

          accordionItemHeader.classList.toggle("active");

          if (accordionItemHeader.classList.contains("active") && accordionItemBody) {
            accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
          } else if (accordionItemBody) {
            accordionItemBody.style.maxHeight = 0;
          }
        });
      });
    });
  }

  faqsAccordion();
});


// SCRIPT FOR ACCORDIANS FAQS


// Full video script

document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById("fullVideoMain");
  const playButton = document.getElementById("fullVideoPLayBtn");

  playButton.addEventListener("click", function () {
    if (video.paused) {
      video.play();
      playButton.classList.add("hidden");
    } else {

      video.pause();
      playButton.classList.remove("hidden");
    }
  });

  video.addEventListener("click", function () {
    if (!video.paused) {
      video.pause();
      playButton.classList.remove("hidden");
    }
  });
});

// Full video script

// modal tab script

document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll('.modal-tab-button');
  const tabContents = document.querySelectorAll('.modal-tab-content');

  function switchTab(index) {
    tabContents.forEach(content => content.classList.remove('active'));

    tabContents[index].classList.add('active');

    tabButtons.forEach(button => button.classList.remove('active'));

    tabButtons[index].classList.add('active');
  }

  tabButtons.forEach((button, index) => {
    button.addEventListener('click', function () {
      switchTab(index);
    });
  });

  switchTab(0);
});

// modal tab script 

// progress bar script

document.addEventListener("DOMContentLoaded", function () {
  const progressBars = document.querySelectorAll('.progress');

  progressBars.forEach(function (bar) {
    const progressValue = bar.getAttribute('data-progress-prod-det');
    bar.style.setProperty('--progress-width', progressValue + '%');
    const valueElement = bar.closest('.progress_bar_item').querySelector('.item_value');
    valueElement.textContent = progressValue + '%';
  });
});

// progress bar script
